"use client"
import * as React from "react"
import {Box} from "@mui/material"
import Grid from "@mui/material/Grid"
import FooterWrapper from "@/ui/layouts/FooterWrapper"
import FaqList from "@/ui/screens/faq/FaqList"


export default function FAQWrapper () {

  return (
    <React.Suspense fallback={<div />}>
      <Box
        sx={{
          p: 2,
          flexGrow: 1,
          pt: { xs: 8, md: 10 },
        }}
      >
        <Grid
          container
          alignItems="flex-start"
          justifyContent="center"
          spacing={{ xs: 1, lg: 3 }}
        >
          <Grid size={{ xs: 12, sm: 12, md: 11, lg: 11, xl: 8 }}>
            <FaqList />
            <FooterWrapper />
          </Grid>
        </Grid>
      </Box>
    </React.Suspense>
  )
}